// extracted by css-extract-rspack-plugin
export default {"wrapper":"_39cd024c"};